import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import { FaArrowAltCircleLeft, FaTimesCircle } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const AddBill = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSecondModalOpen, setIsSecondModalOpen] = useState(false);
  const [isThirdModalOpen, setIsThirdModalOpen] = useState(false);
  const [currentDate, setCurrentDate] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const [currentDate1, setCurrentDate1] = useState();
  const [formData, setFormData] = useState({
    container_no: "",
    location: "",
    customer_name: "",
    price: null,
    Qty: 1,
  });

  const [secondModalFormData, setSecondModalFormData] = useState({
    notes: "",
    price: null,
    Qty: 1,
  });
  const [thirdModalFormData, setThirdModalFormData] = useState({
    extraCharge: "",
    price: null,
    Qty: 1,
    vat: "",
  });

  const [billData, setBillData] = useState({
    name: "",
    email: "",
    vatNo: "",
    company: "",
    bl_no: "",
    invoice_number: "",
    vatPercentage: null,
    extraChargeDescription: "",
    paidStatus: false,
    paidAmount: 0,
    creditAmount: 0,
    extraChargeData: [],
    fieldsData: [],
    date: currentDate1,
    totalAmount: 0,
    description: "",
  });

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const openSecondModal = () => setIsSecondModalOpen(true);
  const closeSecondModal = () => setIsSecondModalOpen(false);

  const openThirdModal = () => setIsThirdModalOpen(true);
  const closeThirdModal = () => setIsThirdModalOpen(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSecondModalInputChange = (e) => {
    const { name, value } = e.target;
    setSecondModalFormData({
      ...secondModalFormData,
      [name]: value,
    });
  };
  const handleThirdModalInputChange = (e) => {
    const { name, value } = e.target;
    setThirdModalFormData({
      ...thirdModalFormData,
      [name]: value,
    });
  };

  const handleBillDataChange = (e) => {
    const { name, value } = e.target;
    setBillData({
      ...billData,
      [name]: value,
    });
  };
  let totalQuantity = 0;
  for (let index = 0; index < billData.fieldsData?.length; index++) {
    // console.log(index, 'asdf');
    // const element = fieldBill2[index];
    const quantity =
      billData.fieldsData[index]?.price * billData.fieldsData[index]?.Qty;
    totalQuantity += quantity;
  }

  let GetExtraCharge = billData.extraChargeData;
  let totalQuantityCharge = 0;
  for (let index = 0; index < GetExtraCharge?.length; index++) {
    // console.log(index, 'asdf');
    // const element = GetExtraCharge[index];
    const quantity =
      Number(GetExtraCharge[index]?.price) * Number(GetExtraCharge[index]?.Qty);
    totalQuantityCharge += quantity;
  }
  const findVatPercentage = totalQuantity
    ? (Number(billData?.vatPercentage) / 100) * Number(totalQuantity)
    : 0;
  const findVatPercentageExtraCharge = totalQuantityCharge
    ? (Number(GetExtraCharge[0]?.vat) / 100) * Number(totalQuantityCharge)
    : 0;
  const paidamount =
    totalQuantity +
    findVatPercentage +
    totalQuantityCharge +
    findVatPercentageExtraCharge;
  // console.log(paidamount, "new");

  const [uploading, setUploading] = useState(false);
  const handleFormSubmit = (e) => {
    e.preventDefault();
    setBillData((prevData) => ({
      ...prevData,
      fieldsData: [...prevData.fieldsData, formData],
      paidAmount:
        totalQuantity +
        findVatPercentage +
        totalQuantityCharge +
        findVatPercentageExtraCharge,
      totalAmount:
        totalQuantity +
        findVatPercentage +
        totalQuantityCharge +
        findVatPercentageExtraCharge,
    }));
    setFormData({
      container_no: "",
      location: "",
      customer_name: "",
      price: null,
      Qty: 1,
    });
    closeModal();
  };

  const handleSecondModalFormSubmit = (e) => {
    e.preventDefault();
    setBillData((prevData) => ({
      ...prevData,
      extraChargeData: [...prevData.extraChargeData, secondModalFormData],
    }));
    setSecondModalFormData({
      notes: "",
      price: null,
      Qty: 1,
    });
    closeSecondModal();
  };
  const handleThirdModalFormSubmit = (e) => {
    e.preventDefault();
    setBillData((prevData) => ({
      ...prevData,
      extraChargeData: [...prevData.extraChargeData, thirdModalFormData],
    }));
    setThirdModalFormData({
      descrption: "",
      price: null,
      Qty: 1,
      vat: 0,
    });
    closeThirdModal(); // Close the modal after submission
  };
  const navigate = useNavigate();

  const handleBillFormSubmit = async (e) => {
    e.preventDefault();
    setUploading(true);
    const ApiData = {
      name: billData.name,
      email: billData.email,
      vatNo: billData.vatNo,
      company: billData.company,
      bl_no: billData.bl_no,
      invoice_number: billData.invoice_number,
      vatPercentage: billData.vatPercentage,
      extraChargeDescription: billData.extraChargeDescription,
      paidStatus: billData.paidStatus,
      paidAmount: paidamount,
      creditAmount: 0,
      fieldsData: billData.fieldsData,
      date: currentDate1,
      extraChargeData: billData.extraChargeData,
      totalAmount: paidamount,
    };

    try {
      const response = await axios.post(
        "https://web.fajrmuttrahtrading.com/bill/create-bill",
        ApiData
      );
      // console.log("Data saved successfully:", response.data);
      if (response.data.status == true) {
        navigate(`/view/${response.data.result._id}`);
        setUploading(false);
      } else {
        window.alert(response.data.message);
        // console.log("not showing");
        setUploading(false);
      }
      // Reset bill data after successful submission
      setBillData({
        name: "",
        email: "",
        vatNo: "",
        company: "",
        bl_no: "",
        invoice_number: "",
        vatPercentage: null,
        extraChargeDescription: "",
        paidStatus: false,
        paidAmount: 0,
        creditAmount: 0,
        extraChargeData: [],
        fieldsData: [],
        date: currentDate1,
        totalAmount: 0,
      });
    } catch (error) {
      if (error.response) {
        setUploading(false);
        window.alert("Response error:", error.response.data);
      } else if (error.request) {
        setUploading(false);
        window.alert("Request error:", error.request);
      } else {
        setUploading(false);
        window.alert("Error:", error.message);
      }
    }

    // console.log(ApiData, "&&&&&&api&&&&& Data");
  };
  useEffect(() => {
    const getCurrentDate = () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now.getDate().toString().padStart(2, "0");
      setCurrentDate(`${year}-${month}-${day}`);
    };

    getCurrentDate();

    // Simulate loading for 2 seconds
    // setTimeout(() => {
    //   // setLoading(false);
    // }, 2000);
  }, []);

  return (
    <>
      <Header title={"Add Bill"} />
      <div className="container mx-auto my-10 px-4 sm:px-8">
        <div className="mx-auto xl:max-w-3xl h-full p-4 flex bg-white rounded-lg shadow overflow-hidden">
          <Link to="/view">
            <FaArrowAltCircleLeft size={28} />
          </Link>
          <div className="w-full my-10">
            <form onSubmit={handleBillFormSubmit}>
              <div className="mb-4 mt-6">
                <label
                  className="block text-gray-700 text-base font-semibold mb-2"
                  htmlFor="invoice-no"
                >
                  Invoice No :
                </label>
                <div className="flex gap-3">
                  <input
                    className="text-sm appearance-none rounded w-full py-2 px-3 text-gray-700 bg-gray-200 leading-tight focus:outline-none focus:shadow-outline h-10"
                    id="invoice-no"
                    type="text"
                    placeholder="Invoice Number"
                    name="invoice_number"
                    value={billData.invoice_number}
                    onChange={handleBillDataChange}
                  />
                  {/* <div className=" font-semibold shadow-md bg-gray-50 rounded-xl right-0 mt-2 mr-3 text-gray-600"> */}
                  <input
                    type="date"
                    // id="id"
                    name="date"
                    placeholder="placeholder"
                    id="date"
                    className="mx-2 bg-slate-500 p-2 text-white"
                    value={currentDate}
                    onChange={(e) => {
                      setCurrentDate(e.target.value);
                      const dateStr = e.target.value;
                      const formattedDate = dateStr.replace(
                        /(\d{4})-0?(\d+)-0?(\d+)/,
                        "$2/$3/$1"
                      );
                      // const formattedDate = reformatDate(e.target.value);
                      // const { year, month, day } = e.target.value;
                      setCurrentDate1(formattedDate);
                      // console.log(
                      //   e.target.value,
                      //   "date setting",
                      //   new Date().toISOString(0, 10)
                      // );
                    }}
                  />
                  {/* </div> */}
                </div>
              </div>

              <h1
                className="text-2xl font-bold"
                // onClick={openThirdModal}
              >
                Add Bill to :
              </h1>

              <div className="mb-4 mt-6">
                <label
                  className="block text-gray-700 text-sm font-semibold mb-2"
                  htmlFor="bl-no"
                >
                  Bl No :
                </label>
                <input
                  className="text-sm appearance-none uppercase rounded w-full py-2 px-3 text-gray-700 bg-gray-200 leading-tight focus:outline-none focus:shadow-outline h-10"
                  id="bl-no"
                  type="text"
                  placeholder="Bl Number"
                  name="bl_no"
                  value={billData.bl_no}
                  onChange={handleBillDataChange}
                />
              </div>
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-semibold mb-2"
                  htmlFor="company"
                >
                  Company
                </label>
                <input
                  className="text-sm bg-gray-200 appearance-none rounded w-full py-2 px-3 text-gray-700 mb-1 leading-tight focus:outline-none focus:shadow-outline h-10"
                  id="company"
                  type="text"
                  name="company"
                  value={billData.company}
                  onChange={handleBillDataChange}
                  placeholder="Company Name"
                />
              </div>
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-semibold mb-2"
                  htmlFor="name"
                >
                  Name:
                </label>
                <input
                  className="text-sm bg-gray-200 appearance-none rounded w-full py-2 px-3 text-gray-700 mb-1 leading-tight focus:outline-none focus:shadow-outline h-10"
                  id="name"
                  type="text"
                  name="name"
                  value={billData.name}
                  onChange={handleBillDataChange}
                  placeholder="Name:"
                />
              </div>
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-semibold mb-2"
                  htmlFor="vatNo"
                >
                  Vat No:
                </label>
                <input
                  className="text-sm bg-gray-200 appearance-none rounded w-full py-2 px-3 text-gray-700 mb-1 leading-tight focus:outline-none focus:shadow-outline h-10"
                  id="vatNo"
                  type="text"
                  name="vatNo"
                  value={billData.vatNo}
                  onChange={handleBillDataChange}
                  placeholder="vatNo"
                />
              </div>
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-semibold mb-2"
                  htmlFor="email"
                >
                  Reference No:
                </label>
                <input
                  className="text-sm bg-gray-200 appearance-none rounded w-full py-2 px-3 text-gray-700 mb-1 leading-tight focus:outline-none focus:shadow-outline h-10"
                  id="email"
                  type="text"
                  name="email"
                  value={billData.email}
                  onChange={handleBillDataChange}
                  placeholder="Reference Number"
                />
              </div>

              <div className="flex w-full mt-8 px-5">
                <button
                  onClick={openModal}
                  className="w-full bg-gray-500 text-center cursor-pointer hover:bg-grey-900 text-white text-sm py-2 px-4 font-semibold rounded-full focus:outline-none focus:shadow-outline h-10"
                  type="button"
                >
                  Add Container
                </button>
              </div>

              {/* <div className="flex w-full mt-8 px-5">
                <button
                  onClick={openSecondModal}
                  className="w-full bg-gray-500 text-center cursor-pointer hover:bg-grey-900 text-white text-sm py-2 px-4 font-semibold rounded-full focus:outline-none focus:shadow-outline h-10"
                  type="button"
                >
                  Add Another
                </button>
              </div> */}
              <div className="flex w-full mt-8 px-5">
                <button
                  onClick={openThirdModal}
                  className="w-full bg-gray-500 text-center cursor-pointer hover:bg-grey-900 text-white text-sm py-2 px-4 font-semibold rounded-full focus:outline-none focus:shadow-outline h-10"
                  type="button"
                >
                  Add Extra Charges
                </button>
              </div>

              <div className="mb-6 mt-6">
                <label
                  className="block text-gray-700 text-sm font-semibold mb-2"
                  htmlFor="vat-tax"
                >
                  Vat Tax (%) :
                </label>
                <input
                  className="text-sm bg-gray-200 appearance-none rounded w-full py-2 px-3 text-gray-700 mb-1 leading-tight focus:outline-none focus:shadow-outline h-10"
                  id="vat-tax"
                  type="number"
                  placeholder="VAT Tax"
                  name="vatPercentage"
                  value={billData.vatPercentage}
                  onChange={handleBillDataChange}
                />
              </div>
              <div className="mb-6 mt-6">
                <label
                  className="block text-gray-700 text-sm font-semibold mb-2"
                  htmlFor="vat-tax"
                >
                  Description :
                </label>
                <input
                  className="text-sm bg-gray-200 appearance-none rounded w-full py-2 px-3 text-gray-700 mb-1 leading-tight focus:outline-none focus:shadow-outline h-10"
                  id="vat-tax"
                  // type="number"
                  placeholder="Description"
                  name="description"
                  value={billData.description}
                  onChange={handleBillDataChange}
                />
              </div>

              <div className="flex w-full mt-8">
                <button
                  className={`w-full bg-gray-800 hover:bg-grey-900 text-white text-base  font-semibold rounded focus:outline-none focus:shadow-outline  ${
                    uploading ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                  type="submit"
                >
                  {uploading ? (
                  <svg
                    className="animate-spin h-5 mr-3"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A8.001 8.001 0 0112 4.472v3.497L6.472 17.29zm11.445-11.445a8.003 8.003 0 011.273 10.528l-4.71-4.71 3.437-3.437z"
                    ></path>
                  </svg>
                ) : (
                  <svg
                    className="h-3 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={1}
                      // d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                    />
                  </svg>
                )}
                <span className="ml-1">
                  {uploading ? "Generating..." : "Generate bill"}
                </span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 flex items-center  justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded shadow-lg sm:max-w-lg w-full">
            <div className="flex items-center justify-between">
              <h2 className="text-xl font-bold mb-4">Add Container</h2>
              <p className="mb-2 cursor-pointer">
                <FaTimesCircle onClick={closeModal} size={25} />
              </p>
            </div>
            <form onSubmit={handleFormSubmit}>
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-semibold mb-2"
                  htmlFor="container_no"
                >
                  Container No
                </label>
                <input
                  className="text-sm bg-gray-200 appearance-none rounded w-full py-2 px-3 text-gray-700 mb-1 leading-tight focus:outline-none focus:shadow-outline h-10"
                  id="container_no"
                  type="text"
                  name="container_no"
                  value={formData.container_no}
                  onChange={handleInputChange}
                />
              </div>

              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-semibold mb-2"
                  htmlFor="location"
                >
                  Location
                </label>
                <input
                  className="text-sm bg-gray-200 appearance-none rounded w-full py-2 px-3 text-gray-700 mb-1 leading-tight focus:outline-none focus:shadow-outline h-10"
                  id="location"
                  type="text"
                  name="location"
                  value={formData.location}
                  onChange={handleInputChange}
                />
              </div>

              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-semibold mb-2"
                  htmlFor="customer_name"
                >
                  Customer Name
                </label>
                <input
                  className="text-sm bg-gray-200 appearance-none rounded w-full py-2 px-3 text-gray-700 mb-1 leading-tight focus:outline-none focus:shadow-outline h-10"
                  id="customer_name"
                  type="text"
                  name="customer_name"
                  value={formData.customer_name}
                  onChange={handleInputChange}
                />
              </div>

              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-semibold mb-2"
                  htmlFor="price"
                >
                  Price
                </label>
                <input
                  className="text-sm bg-gray-200 appearance-none rounded w-full py-2 px-3 text-gray-700 mb-1 leading-tight focus:outline-none focus:shadow-outline h-10"
                  id="price"
                  type="number"
                  name="price"
                  value={formData.price}
                  onChange={handleInputChange}
                />
              </div>

              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-semibold mb-2"
                  htmlFor="Qty"
                >
                  Quantity
                </label>
                <input
                  className="text-sm bg-gray-200 appearance-none rounded w-full py-2 px-3 text-gray-700 mb-1 leading-tight focus:outline-none focus:shadow-outline h-10"
                  id="Qty"
                  type="number"
                  name="Qty"
                  value={formData.Qty}
                  onChange={handleInputChange}
                />
              </div>

              <div className="flex items-center justify-between">
                <button
                  className="bg-gray-800 w-full mt-4 hover:bg-grey-900 text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                  type="submit"
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {isSecondModalOpen && (
        <div className="fixed inset-0 flex items-center  justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded shadow-lg sm:max-w-lg w-full">
            <div className="flex items-center justify-between">
              <h2 className="text-xl font-bold mb-4">Add Extra Charge</h2>
              <p className="mb-2 cursor-pointer">
                <FaTimesCircle onClick={closeSecondModal} size={25} />
              </p>
            </div>
            <form onSubmit={handleSecondModalFormSubmit}>
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-semibold mb-2"
                  htmlFor="notes"
                >
                  Notes
                </label>
                <input
                  className="text-sm bg-gray-200 appearance-none rounded w-full py-2 px-3 text-gray-700 mb-1 leading-tight focus:outline-none focus:shadow-outline h-10"
                  id="notes"
                  type="text"
                  name="notes"
                  value={secondModalFormData.notes}
                  onChange={handleSecondModalInputChange}
                />
              </div>

              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-semibold mb-2"
                  htmlFor="price"
                >
                  Price
                </label>
                <input
                  className="text-sm bg-gray-200 appearance-none rounded w-full py-2 px-3 text-gray-700 mb-1 leading-tight focus:outline-none focus:shadow-outline h-10"
                  id="price"
                  type="number"
                  name="price"
                  value={secondModalFormData.price}
                  onChange={handleSecondModalInputChange}
                />
              </div>

              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-semibold mb-2"
                  htmlFor="Qty"
                >
                  Quantity
                </label>
                <input
                  className="text-sm bg-gray-200 appearance-none rounded w-full py-2 px-3 text-gray-700 mb-1 leading-tight focus:outline-none focus:shadow-outline h-10"
                  id="Qty"
                  type="number"
                  name="Qty"
                  value={secondModalFormData.Qty}
                  onChange={handleSecondModalInputChange}
                />
              </div>

              <div className="flex items-center justify-between">
                <button
                  className="bg-gray-800 w-full mt-4 hover:bg-grey-900 text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                  type="submit"
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {isThirdModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded shadow-lg sm:max-w-lg w-full">
            <div className="flex items-center justify-between">
              <h2 className="text-2xl font-bold mb-4">Add Extra Charges</h2>
              <p className="mb-2 cursor-pointer">
                <FaTimesCircle onClick={closeThirdModal} size={25} />
              </p>
            </div>
            <form onSubmit={handleThirdModalFormSubmit}>
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-semibold mb-2"
                  htmlFor="descrption"
                >
                  Description
                </label>
                <textarea
                  className="text-sm bg-gray-200 appearance-none rounded w-full py-2 px-3 text-gray-700 mb-1 leading-tight focus:outline-none focus:shadow-outline"
                  id="descrption"
                  name="descrption"
                  rows={6}
                  value={thirdModalFormData.descrption}
                  onChange={handleThirdModalInputChange}
                />
              </div>
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-semibold mb-2"
                  htmlFor="price"
                >
                  Price
                </label>
                <input
                  className="text-sm bg-gray-200 appearance-none rounded w-full py-2 px-3 text-gray-700 mb-1 leading-tight focus:outline-none focus:shadow-outline h-10"
                  id="price"
                  name="price"
                  type="number"
                  value={thirdModalFormData.price}
                  onChange={handleThirdModalInputChange}
                />
              </div>
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-semibold mb-2"
                  htmlFor="Qty"
                >
                  Quantity
                </label>
                <input
                  className="text-sm bg-gray-200 appearance-none rounded w-full py-2 px-3 text-gray-700 mb-1 leading-tight focus:outline-none focus:shadow-outline h-10"
                  id="Qty"
                  name="Qty"
                  type="number"
                  value={thirdModalFormData.Qty}
                  onChange={handleThirdModalInputChange}
                />
              </div>
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-semibold mb-2"
                  htmlFor="vat"
                >
                  VAT (%)
                </label>
                <input
                  className="text-sm bg-gray-200 appearance-none rounded w-full py-2 px-3 text-gray-700 mb-1 leading-tight focus:outline-none focus:shadow-outline h-10"
                  id="vat"
                  name="vat"
                  type="number"
                  value={thirdModalFormData.vat}
                  onChange={handleThirdModalInputChange}
                />
              </div>
              <div className="flex items-center justify-between">
                <button
                  className="bg-gray-800 w-full mt-4 hover:bg-grey-900 text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                  type="submit"
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default AddBill;
